import { useContext } from "react";

import * as dialogs from "dialogs/constants";

import { SetDialogContext } from "contexts/setDialogContext";

export default function useDialogs() {
  const setDialog = useContext(SetDialogContext);

  function showAddAccountDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_ACCOUNT, args });
  }

  function showEditAccountDialog(args) {
    setDialog({ name: dialogs.DIALOG_EDIT_ACCOUNT, args });
  }

  function showCreateUpdateHmacDialog(id, initialValues) {
    setDialog({
      name: dialogs.DIALOG_UPDATE_HMAC,
      args: { id, initialValues },
    });
  }

  function showDeleteUpdateHmacDialog({ name, selected, onSuccessCallback }) {
    setDialog({
      name: dialogs.DIALOG_DELETE_HMAC,
      args: { selected, name, onSuccessCallback },
    });
  }

  function showAddFeatureGroupDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_FEATURE_GROUP, args });
  }

  function showAddFeatureTypeDialog(groupId) {
    setDialog({ name: dialogs.DIALOG_ADD_FEATURE_TYPE, args: { groupId } });
  }

  function showCreateLicenseLimitDialog(args) {
    setDialog({ name: dialogs.DIALOG_CREATE_LICENSE_LIMIT, args });
  }

  function showCreateLicenseTemplateDialog(args) {
    setDialog({ name: dialogs.DIALOG_CREATE_LICENSE_TEMPLATE, args });
  }

  function showUpdateLicenseTemplateDialog(licenseInfo) {
    setDialog({
      name: dialogs.DIALOG_UPDATE_LICENSE_TEMPLATE,
      args: { licenseInfo },
    });
  }

  function showUpdateLicenseLimitDialog(limitInfo) {
    setDialog({
      name: dialogs.DIALOG_UPDATE_LICENSE_LIMIT,
      args: { limitInfo },
    });
  }

  function showUpdateLicenseTemplateLimitDialog(limitInfo) {
    setDialog({
      name: dialogs.DIALOG_UPDATE_LICENSE_TEMPLATE_LIMIT,
      args: { limitInfo },
    });
  }

  function showAddVersionDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_VERSION, args });
  }

  function showAddLocaleDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_VERSION_LOCALE, args });
  }

  function showAddIUVersionDialog() {
    setDialog({ name: dialogs.DIALOG_ADD_IU_VERSION });
  }

  function showAssignFilesToVersionDialog(versionId, selected, onSuccessFunc) {
    setDialog({
      name: dialogs.DIALOG_ASSIGN_FILES_TO_VERSION,
      args: { versionId, selected, onSuccessFunc },
    });
  }

  function showCreatePushCenter(centerType) {
    setDialog({
      name: dialogs.DIALOG_CREATE_PUSH_CENTER,
      args: { centerType },
    });
  }

  function showAddGroupDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_ROLE, args });
  }

  function showAddUserDialog(args) {
    setDialog({ name: dialogs.DIALOG_ADD_USER, args });
  }

  function showEditUserDialog(args) {
    setDialog({ name: dialogs.DIALOG_EDIT_USER, args });
  }

  function showAboutDialog(args) {
    setDialog({ name: dialogs.DIALOG_ABOUT, args });
  }

  function showUpdateBillingUrlDialog(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_BILLING_URL, args });
  }

  function showUpdateOktaSettings(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_OKTA_SETTINGS, args });
  }

  function showUpdateStmpSettings(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_SMTP_SETTINGS, args });
  }

  function showUpdateFtpSettings(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_FTP_SETTINGS, args });
  }

  function showUpdateActionLogSettings(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_ACTION_LOG_SETTINGS, args });
  }

  function showUpdatePatchTagDialog(args) {
    setDialog({
      name: dialogs.DIALOG_UPDATE_PATCH_TAG,
      args,
    });
  }

  function showDeletePatchTagDialog(args) {
    setDialog({
      name: dialogs.DIALOG_DELETE_PATCH_TAG,
      args,
    });
  }

  function showUpdateLicenseCertificateDialog(args) {
    setDialog({ name: dialogs.DIALOG_UPDATE_LICENSE_CERTIFICATE, args });
  }

  function showUpdateAccountDealerInfoDialog(args) {
    setDialog({ name: dialogs.UPDATE_ACCOUNT_DEALER_INFO, args });
  }

  function showCreateAccountNoteDialog(args) {
    setDialog({ name: dialogs.CREATE_ACCOUNT_NOTE, args });
  }

  function showUpdateAccountNoteDialog(args) {
    setDialog({ name: dialogs.UPDATE_ACCOUNT_NOTE, args });
  }

  function showCreateAccountAppThemeDialog(args) {
    setDialog({ name: dialogs.CREATE_ACCOUNT_APP_THEME, args });
  }

  function showUpdateAccountAppThemeDialog(args) {
    setDialog({ name: dialogs.UPDATE_ACCOUNT_APP_THEME, args });
  }

  function showConfirmDialog({
    title,
    subTitle,
    Icon,
    submitButtonName,
    cancelButtonName,
    variant,
    initialValues,
    mutationQueries,
    refetchQueries,
    mutationOptions,
    onSuccessMessage,
    onSuccessCallback,
  }) {
    setDialog({
      name: dialogs.DIALOG_CONFIRM,
      args: {
        title,
        subTitle,
        Icon,
        submitButtonName,
        cancelButtonName,
        variant,
        initialValues,
        mutationQueries,
        refetchQueries,
        mutationOptions,
        onSuccessMessage,
        onSuccessCallback,
      },
    });
  }

  return {
    showConfirmDialog,
    showAddAccountDialog,
    showEditAccountDialog,
    showAddFeatureGroupDialog,
    showAddFeatureTypeDialog,
    showCreateLicenseTemplateDialog,
    showUpdateLicenseTemplateDialog,
    showCreateLicenseLimitDialog,
    showUpdateLicenseLimitDialog,
    showUpdateLicenseTemplateLimitDialog,
    showAddVersionDialog,
    showAddLocaleDialog,
    showAddIUVersionDialog,
    showAssignFilesToVersionDialog,
    showCreatePushCenter,
    showAddGroupDialog,
    showAddUserDialog,
    showEditUserDialog,
    showCreateUpdateHmacDialog,
    showDeleteUpdateHmacDialog,
    showAboutDialog,
    showUpdateBillingUrlDialog,
    showUpdateOktaSettings,
    showUpdateStmpSettings,
    showUpdateActionLogSettings,
    showUpdateFtpSettings,
    showUpdatePatchTagDialog,
    showDeletePatchTagDialog,
    showUpdateLicenseCertificateDialog,
    showUpdateAccountDealerInfoDialog,
    showCreateAccountNoteDialog,
    showUpdateAccountNoteDialog,
    showCreateAccountAppThemeDialog,
    showUpdateAccountAppThemeDialog,
  };
}
